import Link from 'next/link';
import { Button } from '@goodneighbor/ui';
import { useHasJWT } from '@/hooks/useJWT';
import styles from './cancellationCard.module.scss';

export default function CancellationCard({
  onManageClick
}: {
  onManageClick?: () => void;
}) {
  const isAuthenticated = useHasJWT();

  return (
    <div className={styles.cancellationCard}>
      <h3 className={styles.title}>Cancellations</h3>
      <div>
        Visit your account to{' '}
        {isAuthenticated ? (
          <Link href="/volunteer/my-events" className={styles.highlight}>
            manage your registration.
          </Link>
        ) : (
          <Button
            color="link-color"
            size="xs"
            onClick={() => {
              if (onManageClick) {
                onManageClick();
              }
            }}
            className={styles.highlight}
          >
            manage your registration.
          </Button>
        )}
      </div>
    </div>
  );
}
